var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add or Edit Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-/-Add-Contact-/-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.25,
    cy: 17.25,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.25,
    y1: 14.25,
    x2: 17.25,
    y2: 20.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 17.25,
    x2: 20.25,
    y2: 17.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,17.25 C0.751543788,14.9833735 1.89011273,12.8686992 3.78149087,11.6195848 C5.672869,10.3704703 8.06475703,10.1535408 10.15,11.042",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 4.875,
    r: 4.125
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContact);
export default __webpack_public_path__ + "static/media/add-contact.d9def4681ecbc351d7151d85185e076d.svg";
export { ForwardRef as ReactComponent };